import app from "../main.js"
import errorsFactory from "./errorsFactory.js"

// TODO: should be deleted once we add responseInterceptor and refactor api/

/**
 * Handle Errors
 * @description Handles possible errors after API call
 * things like authorization, expired token
 */

export default res => {
	if (
		res.errors &&
		res.errors.find(
			item => item.extensions && item.extensions.code === "authorization"
		)
	) {
		// If it's some kind of auth/authorization error
		if (
			res.errors[0] &&
			res.errors[0].message.includes("invalid or expired token")
		) {
			// If token expired log out the user and redirect to login
			window.TK = null
			window.location = `/${app.$store.state.tenantId}/login?loggedout=true`
			return Promise.resolve(
				errorsFactory({ code: "you_have_been_logged_out" })
			)
		} else {
			// If it's authorization error - you don't have permissions to do this action
			return Promise.resolve(errorsFactory({ code: "authorization" }))
		}
	} else {
		// If there are errors but it's something else than authorization
		return Promise.resolve(errorsFactory({ code: "general" }))
	}
}
